import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastNotification = ({ show, onClose, message }) => (
  <ToastContainer position="top-end" className="p-3" z-index="2000 !important">
    <Toast show={show} onClose={onClose} bg="warning" delay={5000} autohide>
      <Toast.Header>
        <strong className="me-auto">Info</strong>
      </Toast.Header>
      <Toast.Body>{message}</Toast.Body>
    </Toast>
  </ToastContainer>
);

export default ToastNotification;
